import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const CountryGroup = iotsUtils.fromList(constants.country.countryGroups);
